export default function anonLatLng(input: string): string {
  const [latStr, lngStr] = input.split(",")

  const lat = parseFloat(latStr)
  const lng = parseFloat(lngStr)

  if (isNaN(lat) || isNaN(lng)) {
    return ""
  }

  const roundedLat = lat.toFixed(2)
  const roundedLng = lng.toFixed(2)

  return `${roundedLat},${roundedLng}`
}
